/**
 * Shadow-client detection (single source of truth for the ?shadow=1 marker).
 *
 * The headless shadow client (cui-shadow-client.service, electron/main.cjs
 * --shadow) loads the app with ?shadow=1 and registers via client:register.
 * It exists so browser-control + screenshots work without a human frontend —
 * it must behave as a READ-ONLY mirror of server state. Renderer code that
 * would PERSIST UI state (layout saves, auto-sync pruning) checks this flag,
 * because a headless renderer's view of "empty"/"visible" differs from the
 * user's and its writes fight the user's windows over shared server state.
 */
export function isShadowClient(): boolean {
  try {
    return new URLSearchParams(window.location.search).get('shadow') === '1';
  } catch {
    return false;
  }
}
